// src/pages/ConferirDocumento/components/ConferenciasTable.js
import React from 'react';

const ConferenciasTable = ({ conferencias, loading, onVerAnalise }) => {
  const formatarData = (isoString) => {
    const data = new Date(isoString);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = String(data.getFullYear()).slice(-2);
    const hora = String(data.getHours()).padStart(2, '0');
    const min = String(data.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} - ${hora}:${min}`;
  };

  const truncarTexto = (texto, maxLength = 80) => {
    if (!texto) return '-';
    if (texto.length <= maxLength) return texto;
    return texto.substring(0, maxLength) + '...';
  };

  return (
    <div className="conferencias-realizadas-section">
      <h3>📂 Conferências Realizadas</h3>

      {loading ? (
        <div className="loading-conferencias">Carregando conferências...</div>
      ) : conferencias.length === 0 ? (
        <div className="sem-conferencias">Nenhuma conferência realizada ainda.</div>
      ) : (
        <table className="conferencias-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Documento</th>
              <th>Análise</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {conferencias.map((conf) => (
              <tr key={conf.id}>
                <td>{formatarData(conf.created_at)}</td>
                <td>{conf.nome_documento}</td>
                <td className="analise-preview">{truncarTexto(conf.resultado_analise)}</td>
                <td>
                  <button
                    className="btn-ver-analise"
                    onClick={() => onVerAnalise(conf)}
                  >
                    👁️ Ver Completa
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ConferenciasTable;